import React, { useContext } from 'react';
import { Transition } from 'react-transition-group';

import {
  CollapsibleMenu,
  MenuItemBase,
  MenuItemBaseContent,
  MenuItemBaseContentItem,
  MenuLink,
  POPPER_TRANSITION_DURATION,
  ToolTipPopover,
  UnreadBadge,
  UnreadBadgeCircle,
} from './styles';
import { SidebarContext } from 'components/Sidebar/Sidebar';
import PopoverBase from 'components/PopoverBase';
// import Icon from 'components/Icon';
import LocalIcon, { LocalIconTypes } from 'ui/LocalIcon';
import { black } from 'utils/style/colors';
import { useMobileDetection } from '../../hooks/useMobileDetection';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store/store';
import { changeStateOFSideBar } from '../../store/app/appSlice';
import Marquee from '../Marquee/Marquee';

const popperModifier = {
  preventOverflow: {
    boundariesElement: 'viewport',
    escapeWithReference: true,
  },
} as any;

type OwnProps = {
  exact?: boolean;
  iconType: LocalIconTypes;
  label: string;
  path: string;
  toPath?: string;
  unreadMessage?: string;
  onClick?: () => void;
};

type ComponentProps = OwnProps & React.HTMLAttributes<HTMLLIElement>;
export const MAX_CHARACTERS_FOR_ANIMATION = 26;

const MenuItem: React.FC<ComponentProps> = ({
  exact = false,
  iconType,
  label,
  path,
  toPath,
  unreadMessage,
  ...restProps
}: ComponentProps) => {
  const sideBarCollapsed = useContext(SidebarContext);
  const isMobile = useMobileDetection();
  const dispatch = useDispatch();
  const isSideBarCollapsed = useSelector(
    (state: RootState) => state.app.UI.sidebar.isSideBarCollapsed
  );

  const handleClick = () => {
    if (isMobile && !isSideBarCollapsed) {
      dispatch(changeStateOFSideBar({ isCollapsed: true }));
    }
  };

  if (sideBarCollapsed) {
    return (
      <PopoverBase
        modifier={popperModifier}
        placement="left-start"
        trigger="hover"
        usePortal={false}
        target={
          <MenuLink
            exact={exact}
            path={path}
            toPath={toPath}
            collapsed={sideBarCollapsed}
          >
            <CollapsibleMenu {...restProps} onClick={handleClick}>
              <LocalIcon iconName={iconType} color={`${black}`} type="sm" />
              {unreadMessage && <UnreadBadgeCircle />}
            </CollapsibleMenu>
          </MenuLink>
        }
        childrenRenderFunc={({ placement, style, ref }) => (
          <Transition in={true} timeout={POPPER_TRANSITION_DURATION} appear>
            {(state) => (
              <ToolTipPopover
                data-placement={placement}
                ref={ref}
                style={style}
                transitionState={state}
              >
                {label}
                {unreadMessage && <UnreadBadge>{unreadMessage}</UnreadBadge>}
              </ToolTipPopover>
            )}
          </Transition>
        )}
      />
    );
  }
  return (
    <MenuLink
      exact={exact}
      path={path}
      toPath={toPath}
      collapsed={sideBarCollapsed}
    >
      <MenuItemBase {...restProps} onClick={handleClick}>
        <MenuItemBaseContent>
          <div
            style={{
              background: 'var(--exact-white)',
              position: 'relative',
              zIndex: 1,
            }}
          >
            {iconType && (
              <LocalIcon iconName={iconType} color={`${black}`} type="sm" />
            )}
          </div>
          <MenuItemBaseContentItem>
            <Marquee text={label} />
          </MenuItemBaseContentItem>
        </MenuItemBaseContent>
        {unreadMessage && <UnreadBadge>{unreadMessage}</UnreadBadge>}
      </MenuItemBase>
    </MenuLink>
  );
};

export default MenuItem;
